import styles from './kalender.module.css'
function Kalender() {
    return (
        <section className={styles.container}>
            <h1>Terminkalender</h1>
            <p>Diese Seite ist aktuell in Bearbeitung!</p>
            <p>Kommen Sie zu einem späteren Zeitpunkt gerne wieder hierhin!</p>
        </section>
    );
}
export default Kalender